/**
 * デバイスがタッチ対応かどうかを判定する関数
 * @returns {boolean} タッチデバイスなら true、そうでなければ false
 */

export function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || window.matchMedia("(pointer: coarse)").matches;
}
